/**
 * CTA Tracking Module
 * Tracks CTA button clicks for GTM analytics
 */

import { trackCTAClick } from './gtm-events.js';

/**
 * Initialize CTA click tracking
 */
export function initCTATracking() {
  // Track hero CTA form submit (which opens registration modal)
  const heroForm = document.querySelector('.hero-section__cta[data-pro-form]');
  if (heroForm) {
    heroForm.addEventListener('submit', () => {
      const buttonText = heroForm.querySelector('button[type="submit"]')?.textContent?.trim() || 'Get Started';
      trackCTAClick(buttonText, 'hero');
    });
  }

  // Track hero demo button click
  const demoButton = document.querySelector('.hero-section__demo-btn');
  if (demoButton) {
    demoButton.addEventListener('click', () => {
      const buttonText = demoButton.querySelector('span')?.textContent?.trim() || 'Watch Demo';
      trackCTAClick(buttonText, 'hero_demo');
    });
  }

  // Track final CTA section - Pro form
  const finalProForm = document.querySelector('.final-cta__card:not(#care-early-access) [data-pro-form]');
  if (finalProForm) {
    finalProForm.addEventListener('submit', () => {
      const buttonText = finalProForm.querySelector('button[type="submit"]')?.textContent?.trim() || 'Get Started';
      trackCTAClick(buttonText, 'final_cta_pro');
    });
  }

  // Track all CTAs with data-track-cta attribute
  // Covers: header-pro, header-care, mobile-pro, mobile-care, hero-pro, hero-care
  const trackableCTAs = document.querySelectorAll('[data-track-cta]');
  trackableCTAs.forEach(cta => {
    cta.addEventListener('click', () => {
      const location = cta.getAttribute('data-track-cta');
      const buttonText = cta.textContent?.trim() || location;
      trackCTAClick(buttonText, location);
    });
  });
}
